<template>
  <div class="ml-1 new-customer-tile ">
    <button class="close back mt-3 ml-2 bg-light back-arrow" style="float:left">
      <b-icon-arrow-left class="vertical-align-middle" @click="$emit('quit', form.displayMode)" />
    </button>
    <button class="close mt-2 mr-2 bg-light">
      <b-icon-x @click="$emit('quit', form.displayMode)" />
    </button>
    <div class="mt-3">
      <div class="d-flex ml-3" :class="{ 'section-disabled': disableEditCustomer }">
        <h4 class="text-black-50 ml-40px">
          Patientenhalter
          <b-icon-pencil-square
            class="clickable"
            @click="
              switchDisplayMode(
                CONSTANTS.ADDRESSBOOK.CUSTOMER_FORM_DISPLAY_MODES.EDIT_MODE
              )
            "
            v-if="
              form.displayMode !==
                CONSTANTS.ADDRESSBOOK.CUSTOMER_FORM_DISPLAY_MODES.NEW_CLIENT &&
                !form.isVet
            "
          />
        </h4>
      </div>

      <div class="font-form">
        <div
          style="width:97%"
          class="mt-2 ml-2"
          v-if="
            form.displayMode ===
              CONSTANTS.ADDRESSBOOK.CUSTOMER_FORM_DISPLAY_MODES
                .DISPLAY_INFORMATION
          "
        >
          <div
            v-if="!loaders.isLoadingClient"
            class="address-book-column-100 d-block"
          >
            <h6 class="futalis-text-green">Rechnungsadresse</h6>
            <p class="mb-0">
              {{ address.prefix }} {{ address.firstname }}
              {{ address.lastname }}
            </p>
            <p class="mb-1">
              {{ address.street1 }} {{ address.street2 }}, <br />
              {{ address.additional_address }} <br v-if="address.additional_address" />
              {{ address.post }}
              {{ address.city }}
            </p>
            <p>{{ form.data.telephone }}</p>
            <div v-if="form.data.isDifferentDeliveryAddress">
              <h6 class="futalis-text-green">Versandadresse</h6>
              <p class="mb-0">
                {{ form.data.deliveryAddress.prefix }}
                {{ form.data.deliveryAddress.firstname }}
                {{ form.data.deliveryAddress.lastname }}
              </p>
              <p class="mb-1">
                {{ form.data.deliveryAddress.street1 }}
                {{ form.data.deliveryAddress.street2 }},<br />
                {{ form.data.deliveryAddress.additional_address }} <br v-if="form.data.deliveryAddress.additional_address" />
                {{ form.data.deliveryAddress.post }}
                {{ form.data.deliveryAddress.city }}
              </p>
            </div>
          </div>
          <div v-else class="center-middle">
            <i
              class="fad fa-spinner-third fa-2x mt-2
                   vertical-align-middle fa-spin futalis-text-green-strong"
            />
          </div>

          <div class="mt-2">
            <h5 class="futalis-text-green" style="padding:0 9px;margin-top:10px">Hunde</h5>
            <div
              v-if="!loaders.isLoadingPets"
              :class="{
                'petslist-overflow': true,
                'plus-delivery': form.data.isDifferentDeliveryAddress
              }"
            >
              <div
                class="py-3 list-pet-container"
                v-for="(pet, index) in form.pets"
                :class="{ clearfix: index % 2 == 0 }"
              >
                <div
                  :style="{
                    background: 'url(\'' + pet.image + '\') no-repeat center'
                  }"
                  class="rounded-circle list-pet-pic clickable mr-0"
                  @click="showPetDetails(pet)"
                >
                  <div
                    v-if="pet.hasSubscription"
                    class="has-subscription-container"
                  >
                    <div />
                  </div>
                  <div v-if="pet.isPuppy" class="is-puppy-container">
                    <div>
                      <p>Welpe</p>
                    </div>
                  </div>
                </div>
                <div class="text-black-50 list-pet-name">{{ pet.name }}</div>
              </div>
              <div class="py-3 list-pet-container">
                <div
                  @click="addNewPet()"
                  class="new-dog list-pet-pic clickable"
                >
                  <img src="https://media.futalis.com/futalis/interface/new-dog.png"
                    class="w-100 rounded-circle "
                    alt=""
                  />
                  <span class="plus-new-dog">
                    <i class="fa fa-plus-circle fa-3x" aria-hidden="true" />
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="center-middle">
              <i
                class="fad fa-spinner-third fa-2x mt-2
                   vertical-align-middle fa-spin futalis-text-green-strong"
              />
            </div>
          </div>
        </div>

        <div v-else class="ml-3 mr-3">
          <form>
            <AddressForm
              v-model="address"
              :activeAutocomplete="activeAutocomplete"
              :autocomplete="autocomplete"
              :config="form.config"
              :selectFromAutoComplete="selectFromAutoComplete"
              :getAddressSuggestions="handleOnGetAddressSuggestions"
              :validations="form.validations.billingAddress"
            />

            <div class="row mt-2">
              <div class="col-12">
                <label for="email" class="ml-1 mb-1">E-MAIL-ADRESSE *</label>
                <input
                  :value="form.data.email"
                  @input="updateFormValue('email', $event.target.value)"
                  type="text"
                  class="text-input mb-2"
                  id="email"
                  :class="{
                    'error-input': form.validations.isEmailInvalid
                  }"
                  @blur="checkEmailAvailability"
                />
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <label class="ml-1 mb-1">TELEFON *</label>
                <input
                  :value="form.data.telephone"
                  @input="updateFormValue('telephone', $event.target.value)"
                  type="text"
                  :class="{
                    'error-input': form.validations.isTelephoneInvalid
                  }"
                  class="text-input"
                />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <input
                  type="checkbox"
                  id="isDeliveryAddressDifferent"
                  class="form-check-inline"
                  :checked="form.data.isDifferentDeliveryAddress"
                  @change="
                    updateFormValue(
                      'isDifferentDeliveryAddress',
                      !!!form.data.isDifferentDeliveryAddress
                    )
                  "
                />
                <label for="isDeliveryAddressDifferent"
                  >abweichende Versandadresse</label
                ><br />
                <input
                  type="checkbox"
                  id="isPraxis"
                  class="form-check-inline"
                  :checked="form.data.isPraxis"
                  @change="updateFormValue('isPraxis', !!!form.data.isPraxis)"
                />
                <label for="isPraxis">gehört zum Praxisteam</label><br />
              </div>
            </div>

            <div v-if="!!!form.data.isDifferentDeliveryAddress" class="row mt-4">
              <div class="col-6">
                <button
                  @click="$emit('saveClient', $event)"
                  class="futalis-btn futalis-button-orange text-white text-center "
                >
                  Speichern
                </button>
              </div>
              <div v-if="form.displayMode ===  'edit'" class="col-6">
                <a
                  @click="$emit('deleteClient', form.data.id, form.data.isPraxis)"
                  class="float-left mt-2"
                  style="color: rgba(0,0,0,.5); cursor: pointer;"
                >
                  Entfernen <span><i class="fal fa-trash-can clickable vertical-align-middle"/></span>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressForm from './AddressForm';
import router from '@/modules/router/config';
import { CONSTANTS } from '@/constants/guide';
import {setCookie} from "@/helpers/userHelper";

export default {
  name: 'CustomerForm',
  props: [
    'form',
    'showPetDetails',
    'getAddressSuggestions',
    'autocomplete',
    'selectAutoComplete',
    'updateIsVerified',
    'closeAddressBook',
    'loaders',
    'disableEditCustomer'
  ],
  components: { AddressForm },
  data() {
    return {};
  },
  methods: {
    selectFromAutoComplete(field, value) {
      this.selectAutoComplete(field, value);
    },
    handleOnGetAddressSuggestions(field) {
      this.getAddressSuggestions('billingAddress', field);
    },
    addNewPet() {
      this.closeAddressBook();
      this.$store.commit('configuratorModule/setClient', {
        id: parseInt(this.form.data.id),
        isVet: parseInt(this.form.data.isVet),
        name: this.form.data.name
      });
      setCookie(
        'client_id',
        this.form.data.isVet ? -1 : this.form.data.id
      );
      router.push({
        name: `Configurator`,
        params: {
          mode: CONSTANTS.CONFIGURATOR.MODES.ADD_PET_TO_CLIENT,
          id: this.form.data.isVet ? -1 : this.form.data.id,
          skipLeaveCartPopup: true
        }
      });
    },
    switchDisplayMode(mode) {
      this.$emit('updateForm', {
        ...this.form,
        displayMode: mode
      });
    },
    updateFormValue(key, value) {
      this.$emit('updateForm', {
        ...this.form,
        data: { ...this.form.data, [key]: value }
      });
    },
    checkEmailAvailability() {
      this.$emit('checkAvailability')
    },
  },
  computed: {
    address: {
      get() {
        return this.form.data.billingAddress;
      },
      set(value) {
        this.updateFormValue('billingAddress', value);
      }
    },
    activeAutocomplete() {
      return (
        this.form.data.billingAddress.country === 'DE' &&
        this.autocomplete.addressType === 'billingAddress'
      );
    }
  }
};
</script>

<style scoped>
.new-customer-tile {
  width: 325px !important;
  height: 768px !important;
}
.font-form {
  font-size: 0.8rem;
}
.help-icon {
  margin-top: 1.8rem;
}
.tooltip {
  opacity: 1 !important;
}
.text-input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.8rem;
  color: #495057;
  background: #fff;
  border: 1px solid #e6e7d5;
}

.new-dog {
  position: relative;
  display: inline-block;
  width: auto;
  height: 120px;
}
.list-pet-container {
  float: left;
}
.list-pet-pic {
  width: 130px;
  height: 130px;
  background-size: auto 100% !important;
}

.plus-new-dog {
  position: absolute;
  right: 17%;
  top: 70%;
  color: #e3e3e3;
}

.has-subscription-container {
  position: relative;
}

.has-subscription-container > div:before {
  content: 'ABO';
}
.has-subscription-container > div {
  position: absolute;
  top: 0;
  right: -10px;
  width: 40px;
  height: 40px;
  background-color: #a8c014;
  color: #ffffff;
  text-align: center;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
}

.is-puppy-container {
  position: relative;
  height: 100%;
  width: 100%;
}

.is-puppy-container > div {
  position: absolute;
  height: 100%;
  width: 100%;
  color: #ffffff;
  border-radius: 50%;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background: -webkit-linear-gradient(
    bottom,
    transparent,
    transparent 85%,
    deepskyblue 85%,
    deepskyblue
  );
}

.is-puppy-container > div > p {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.list-pet-name {
  font-size: 1rem;
  text-align: center;
  overflow: hidden;
  width: 140px;
  padding-top: 5px;
}

.error-input {
  border: 1px solid #ff456e !important;
}

.petslist-overflow {
  max-height: 490px;
  width: 100%;
  overflow: auto;
}
.petslist-overflow.plus-delivery {
  max-height: 405px;
}
@media (max-width: 768px) {
  .petslist-overflow {
    max-height: none;
    height: auto !important;
    margin-right: 0!important ;
    width: calc(100vw - 10px) !important;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .petslist-overflow.plus-delivery {
    max-height: none !important;
  }
  .petslist-overflow::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
  .new-customer-tile {
    min-height: calc(100vh - 5px) !important;
    height: auto !important;
    width: 100% !important;
    position: absolute;
    top: 0;
    margin-left: 0 !important;
  }
  .list-pet-container {
    position: relative;
    width: 50%;
    height: 0;
    padding-bottom: 50%!important;
  }
  .list-pet-pic {
    position: absolute;
    width: calc(100% - 30px) !important;
    height: calc(100% - 30px) !important;
    top: 0;
    left: 5px;
  }
  .list-pet-name {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: auto;
    right: auto;
  }
}
</style>
